import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Product from 'pages/Main/Quality/Product';
import Operations from 'pages/Main/Quality/Operations';

import BrandSelect from 'components/Form/BrandSelect';
import Quality from './Quality';
import { Container, Header, Tabs, Tab, Filters } from './styles';
import useConnect from './connect';

const QualityPage: FC = () => {
  const { selectedBrandId, setSelectedBrandId } = useConnect();

  return (
    <Container>
      <Header>
        <Tabs>
          <Tab label="Quality" to="/quality/quality" />
          <Tab label="Product" to="/quality/product" />
          <Tab label="Operations" to="/quality/operations" />
        </Tabs>

        <Filters>
          <BrandSelect
            setSelectedId={setSelectedBrandId}
            value={selectedBrandId}
            allowAllOption={false}
          />
        </Filters>
      </Header>
      <Switch>
        <Route exact path="/quality/quality">
          <Quality brandId={selectedBrandId} />
        </Route>
        <Route exact path="/quality/product">
          <Product brandId={selectedBrandId} />
        </Route>
        <Route exact path="/quality/operations">
          <Operations brandId={selectedBrandId} />
        </Route>

        <Redirect to="/quality/quality" />
      </Switch>
    </Container>
  );
};

export default QualityPage;
